<template>
  <b-modal id="update" hide-footer @hide="onModalHide">
    <template v-slot:modal-title>Editar Variável para Contrato</template>
    <div class="d-block">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <LabelRequiredField label="tabela" />

            <select
              v-model="contract_variable.table_name"
              class="form-control"
              @change="onTableChange"
            >
              <option :value="'RESIDENT'">Resident</option>
              <option :value="'CUSTOMER'">Customer</option>
              <option :value="'REST_HOME'">Rest Home</option>
            </select>
          </div>

          <div class="col-md-12">
            <LabelRequiredField label="Coluna" />

            <select
              v-model="contract_variable.column_name"
              class="form-control"
            >
              <option
                v-for="column in columnsTableSelected"
                :key="column"
                :value="column"
              >
                {{ column }}
              </option>
            </select>
          </div>

          <div class="col-md-12">
            <LabelRequiredField label="Nome da variável" />

            <input
              type="text"
              v-model="contract_variable.variable"
              class="form-control"
            />
          </div>

          <div class="col-md-12">
            <LabelRequiredField label="descrição da varivel" />

            <textarea
              v-model="contract_variable.description"
              class="form-control"
              maxlength="255"
            ></textarea>
          </div>

          <div class="col-md-12">
            <LabelRequiredField label="Status" />

            <select v-model="contract_variable.active" class="form-control">
              <option :value="1">Ativo</option>
              <option :value="0">Inativo</option>
            </select>
          </div>

          <ErrorsMessages :errors="errors" />

          <div class="col-md-12 text-right">
            <v-btn
              :disabled="loading"
              type="submit"
              class="v-success"
              @click="update"
            >
              <span class="fa fa-check"></span>
              {{ loading ? "Carregando" : "Salvar" }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../components/ErrorsMessages";
import LabelRequiredField from "../components/LabelRequiredField";
import api from "../../services/api";
import toast from "../../components/ToastNotification";

export default {
  name: "UpdateModal",

  components: {
    LabelRequiredField,
    ErrorsMessages,
  },

  props: {
    contract_variable: {
      type: Object,
      required: true,
    },

    columnsResident: {
      type: Array,
      default: () => [],
    },

    columnsCustomer: {
      type: Array,
      default: () => [],
    },

    columnsRestHome: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      errors: [],

      columnsTableSelected: [],

      loading: false,
    };
  },

  mounted() {
    if (this.contract_variable.table_name == "RESIDENT") {
      this.columnsTableSelected = this.columnsResident;
    } else if (this.contract_variable.table_name == "CUSTOMER") {
      this.columnsTableSelected = this.columnsCustomer;
    } else if (this.contract_variable.table_name == "REST_HOME") {
      this.columnsTableSelected = this.columnsRestHome;
    }
  },

  watch: {
    contract_variable() {
      if (this.contract_variable.table_name == "RESIDENT") {
        this.columnsTableSelected = this.columnsResident;
      } else if (this.contract_variable.table_name == "CUSTOMER") {
        this.columnsTableSelected = this.columnsCustomer;
      } else if (this.contract_variable.table_name == "REST_HOME") {
        this.columnsTableSelected = this.columnsRestHome;
      }
    },
  },

  methods: {
    async update() {
      try {
        this.loading = true;

        const id = this.contract_variable.id;
        const table_name = this.contract_variable.table_name;
        const column_name = this.contract_variable.column_name;
        const variable = this.contract_variable.variable;
        const description = this.contract_variable.description;
        const active = this.contract_variable.active;

        let params = {
          id,
          table_name,
          column_name,
          variable,
          description,
          active,
        };

        const response = await api.put("/admin/contract/update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("update");

          toast(message, "success");

          this.errors = [];

          this.$emit("update");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    onTableChange() {
      this.contract_variable.column_name = "";

      this.contract_variable.variable = "";

      this.contract_variable.description = "";

      if (this.contract_variable.table_name == "RESIDENT") {
        this.columnsTableSelected = this.columnsResident;
      } else if (this.contract_variable.table_name == "CUSTOMER") {
        this.columnsTableSelected = this.columnsCustomer;
      } else if (this.contract_variable.table_name == "REST_HOME") {
        this.columnsTableSelected = this.columnsRestHome;
      }
    },

    onModalHide() {
      this.errors = [];

      this.$emit("update");
    },
  },
};
</script>